import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  wrapper: {
    display: 'flex',
    padding: '28px 0',
    justifyContent: 'space-between',
  },
  search: (getGridsWidth: (width: number) => number) => ({
    width: `${getGridsWidth(2)}px`,
  }),
  notice: (getGridsWidth: (width: number) => number) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'flex-start',
    fontSize: '14px',
    lineHeight: '20px',
    color: 'rgba(30, 30, 30, 0.60)',
    width: `${getGridsWidth(2)}px`,
    '& .item': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& svg': {
        width: '16px',
        height: '16px',
      },
    },
  }),
}));
